import { useEffect, useState } from "react";
import { BbotModal, BbotRichTextInput } from "top-component-library";

// Mirrors temporarily-disable-ordering-dialog.html/temporarilyDisableOrderingController.
// One shared dialog for both directions: disabling asks for the message guests will
// see; re-enabling is a single confirm with no fields.
const TemporarilyDisableOrderingDialog = ({ visible, enableOrdering, onClose, onConfirm }) => {
  const [richtext, setRichtext] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (visible) setRichtext("");
  }, [visible]);

  const onOk = async () => {
    setIsSaving(true);
    const succeeded = await onConfirm(enableOrdering ? undefined : richtext);
    setIsSaving(false);
    if (succeeded) onClose();
  };

  return (
    <BbotModal
      title={
        enableOrdering
          ? "Ordering is temporarily disabled, click confirm to re-enable ordering"
          : "Temporarily Disable Ordering"
      }
      visible={visible}
      onCancel={onClose}
      okText="Confirm"
      okButtonProps={{ loading: isSaving }}
      onOk={onOk}
    >
      {!enableOrdering && (
        <div>
          <p>Please enter the message you want to show to customers in the editor below.</p>
          <BbotRichTextInput value={richtext} onChange={setRichtext} />
        </div>
      )}
    </BbotModal>
  );
};

export default TemporarilyDisableOrderingDialog;
